import React from 'react';
import './Graphique.css';
import Card from '../Card';
import ContenueCardBilan from './ContenuCardBilan';

const CardBilan = ({totalConsumption}) => {
  // Données pour les éléments du graphique
  
  return (
    <div>
    <Card color={"#EBE085"} contenu={<ContenueCardBilan totalConsumption={totalConsumption}/>} />
    </div>
  );
};

export default CardBilan;
